<template>
  <div>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="editSkill"
    >
      <i class="material-icons-outlined align-middle">edit</i>
    </a>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      @click="deleteSkill"
    >
      <i class="material-icons-outlined align-middle">delete</i>
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    editSkill: function () {
      this.params.context.componentParent.editSkill(this.params.data);
    },
    deleteSkill: function () {
      this.params.context.componentParent.deleteSkill(this.params.data);
    },
  },
};
</script>
